export const membersWorkSheetId = '1i1qtTGAb_3SQQGfHWaiLUQ-Q7vLY4TzL4TJINSTxD-M';
export const eventsWorkSheetId = '1GhmmeCZQYMlsJuA8ydMNoNNEloSI4ete9juk89RKXzg';
export const timelineWorkSheetId = '1ccSHjT7jpYFY1mvBzwpAbr9XJwuLKwX51k7eQ3K1PSk';
export const profileImagesRepositoryURL = 'https://drive.google.com/drive/u/0/folders/1KJ0uJaUuqCdyaS6hMmn3tNzyvfGdhtjfkG5WE79L0kl3Adv-i0Y8MR34IqTxCt_AUmMFsbX7';
